import { ref } from 'vue'
import { listTags } from '@/services/wootdashTags'

// Etiquetas que não podem ser removidas de uma conversa (CpTag.isProtected no WootDash —
// substitui list_protected_labels do n8n). Carregadas no login; quem precisa só consulta.
const protectedTitles = ref<Set<string>>(new Set())

export async function loadProtectedLabels(token: string): Promise<void> {
  try {
    const tags = await listTags(token)
    protectedTitles.value = new Set(tags.filter(t => t.isProtected).map(t => t.name))
  } catch { /* mantém o que tinha */ }
}

/** Leitura pura do cache atual — vazio até loadProtectedLabels() resolver pela primeira vez. */
export function getProtectedLabelTitles(): Set<string> {
  return protectedTitles.value
}

export function isLabelProtected(title: string): boolean {
  return protectedTitles.value.has(title)
}
